<template>
  <div>
    <top-menu/>
    <slot name="modals"/>

    <section>
      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <slot/>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import topMenu from "../default/topMenu.vue";

export default {
  name: "boxDefault",
  props: {},
  components: {
    topMenu,
  }
}
</script>



// WEBPACK FOOTER //
// src/vue/pages/components/layouts/boxDefault.vue